"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolanaSignIn = void 0;
/** Name of the feature. */
exports.SolanaSignIn = 'solana:signIn';
//# sourceMappingURL=signIn.js.map